export class AddOrderItemResultModel {
    constructor(public startkitAdded: boolean) { }
}
